import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import { useNavigate } from 'react-router-dom';
import { connect } from "react-redux";
import { UpdateLang } from "_actions";
import { logout } from "_actions";
// Swiper CSS'lerini import et
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

const BannerCarouselV2 = (props, { banners = [] }) => {
  const navigate = useNavigate();
  const { currentLang } = props;

  const handleBannerClick = (path) => {
    if (path) {
      navigate(path);
    }
  };
  const _banners = [
    {
      id: 1,
      img: require(`../../../assets/img/banners/rimal/${currentLang}/betbuilder.jpg`),
      gradient: "from-blue-600 to-blue-800",
      path: "/sports"
    },
    {
      id: 2,
      img: require(`../../../assets/img/banners/rimal/${currentLang}/egt.jpg`),

      gradient: "from-secondary-600 to-secondary-800",
      path: "/casino"
    },
    {
      id: 3,
      img: require(`../../../assets/img/banners/rimal/${currentLang}/daily.jpg`),

      gradient: "from-green-600 to-green-800",
      path: "/casino"
    },
    {
      id: 4,
      img: require(`../../../assets/img/banners/rimal/${currentLang}/live.jpg`),

      gradient: "from-purple-600 to-purple-800",
      path: "/live-casino"

    },
    {
      id: 5,
      img: require(`../../../assets/img/banners/rimal/${currentLang}/support.jpg`),

      gradient: "from-purple-600 to-purple-800",
      path: "/contact-us"

    }
    ,
    {
      id: 6,
      img: require(`../../../assets/img/banners/rimal/${currentLang}/highcashout.jpg`),

      gradient: "from-purple-600 to-purple-800",
      path: "/"

    }
    ,
    {
      id: 7,
      img: require(`../../../assets/img/banners/rimal/${currentLang}/livematches.jpg`),

      gradient: "from-purple-600 to-purple-800",
      path: "/sports"

    },
      {
      id: 8,
      img: require(`../../../assets/img/banners/rimal/${currentLang}/bigwin.jpg`),
      gradient: "from-purple-600 to-purple-800",
      path: "/max-win-limits"

    }
  ];

  return (
    <div key={currentLang+"bannerv2"} className="bg-[#ffffff17] md:bg-transparent relative mb-0 mt-0 md:mt-4 p-0 md:p-4 max-w-screen-lg mx-auto">
      {/* 16:9 aspect ratio wrapper */}
      <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
        <Swiper
          modules={[Autoplay, Pagination, Navigation]}
          spaceBetween={0}
          slidesPerView={1}
          loop={true}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
          pagination={{
            clickable: true,
            dynamicBullets: true,
          }}
          navigation={{
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          }}
          className="absolute inset-0 rounded-none md:rounded-xl"
        >
          {_banners.map((banner) => (
            <SwiperSlide key={banner.id}>
              <div
                className="h-full bg-transparent relative cursor-pointer"
                onClick={() => handleBannerClick(banner.path)}
              >
                <div className="absolute inset-0 bg-black opacity-50"></div>
                <div
                  key={banner.id + currentLang}
                  style={{ backgroundImage: `url(${banner.img})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }}
                  className="absolute inset-0 z-10">
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};



const mapStateToProps = (state, props) => {
  const { authentication, game } = state;
  const { user, loggedIn, currentLang } = authentication;
  const { sports, games } = game;
  return {
    user,
    loggedIn,
    sports,
    games,
    currentLang,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(logout()),
    UpdateLang: (data) => dispatch(UpdateLang(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BannerCarouselV2);
